import { render, staticRenderFns } from "./ChildInfo.vue?vue&type=template&id=a76baae4&"
import script from "./ChildInfo.vue?vue&type=script&lang=js&"
export * from "./ChildInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChildInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports